import { Capacitor } from '@capacitor/core'
import { setFeatureFlag } from '@/composables/feature-flags'

export function isNativeApp() {
  return Capacitor.isNativePlatform()
}

export function nativePlatform(): string | undefined {
  return isNativeApp() ? Capacitor.getPlatform() : undefined
}

/**
 * Feature flags that should always be on when running as the native
 * (Capacitor) app, regardless of whatever's been toggled via query string or
 * session storage.
 */
export function applyNativePlatformFeatureFlags() {
  if (isNativeApp()) {
    setFeatureFlag('api_login', true)
  }
}
